module.exports = __webpack_public_path__ + "img/reports.0f8f5d25.svg";